// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","main":"Home_main__3ilkD","header":"Home_header__jgN9+"};